import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader } from "arv-reactcomponents";
import { observer, inject } from "mobx-react";
import ShopAllStylesView from "../ShopAllStylesView";

@inject("BrandStore")
@observer
class ShopAllStylesModal extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
    this.init = this.init.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  init() {
    const { styleIdList } = this.props;
    this.props.BrandStore.getShopAllStylesList(styleIdList).then(() => {
      this.setState({ loading: false });
    });
  }
  render() {
    const { loading } = this.state;
    const { title, closeModal } = this.props;
    const { shopAllStylesList } = this.props.BrandStore;
    return (
      <div className="nw-shopallstyles-modalcontainer">
        {loading && (
          <div className="nw-shopallstyles-loader">
            <Loader />
          </div>
        )}
        {!loading && (
          <ShopAllStylesView.component
            data={shopAllStylesList}
            title={title}
            closeModal={closeModal}
          />
        )}
      </div>
    );
  }
}

ShopAllStylesModal.wrappedComponent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  styleIdList: PropTypes.shape([]).isRequired,
  BrandStore: PropTypes.shape({
    getShopAllStylesList: PropTypes.func.isRequired,
    shopAllStylesList: PropTypes.shape([]).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("BrandStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShopAllStylesModal.wrappedComponent,
  component: ShopAllStylesModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/ShopAllStylesModal/index.js